import type { WebGLRenderer } from '@seddi/three';
import { v4 as uuid } from 'uuid';

import type { ResourcesContext } from './resources/resourcesContext';
import { type SceneViewerConfig } from './sceneViewerConfig';
import { type SceneViewerContext, create as createContext } from './sceneViewerContext';

export type MultiViewElement = SceneViewerContext & {
  readonly domElement: HTMLElement;
  readonly id: string;
};

export const create = (
  config: Partial<SceneViewerConfig>,
  renderer: WebGLRenderer,
  resources: ResourcesContext,
  domElement: HTMLElement,
): MultiViewElement => {
  const context = createContext(config, renderer, resources);
  const id = uuid();
  return { ...context, domElement, id };
};

/**
 * Get its position relative to the page's viewport.
 * @param self
 * @returns
 */
export const getBoundingClientRect = (self: MultiViewElement) => {
  return self.domElement.getBoundingClientRect();
};
